export default "__VITE_ASSET__1iq1SIz1__"